import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        console.warn(`Translation key "${key}" not found for language "${language}"`);
        return key;
      }
    }
    
    return value;
  };

  const formatNumber = (number) => {
    if (language === 'ar') {
      return new Intl.NumberFormat('ar-EG').format(number);
    }
    return new Intl.NumberFormat('en-US').format(number);
  };

  const formatCurrency = (amount, currency = 'USD') => {
    if (language === 'ar') {
      return new Intl.NumberFormat('ar-EG', {
        style: 'currency',
        currency: currency
      }).format(amount);
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  };

  return {
    t,
    language,
    formatNumber,
    formatCurrency
  };
};